'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var reactIntl = require('react-intl');
var StandardTable = require('../../tables/StandardTable/StandardTable.js');
require('../../typography/ErrorText/ErrorText.js');
require('../../typography/LargeDarkText/LargeDarkText.js');
require('../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../typography/MediumDarkText/MediumDarkText.js');
require('../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../typography/MediumText/MediumText.js');
require('../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../../typography/SmallDarkText/SmallDarkText.js');
require('../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
var SmallLinkText = require('../../typography/SmallLinkText/SmallLinkText.js');
require('../../typography/SmallTitleText/SmallTitleText.js');
require('../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../typography/TinyDarkText/TinyDarkText.js');
require('../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../typography/TinyLinkText/TinyLinkText.js');
require('../../typography/TinyTitleText/TinyTitleText.js');
require('../../typography/XXLargeDarkText/XXLargeDarkText.js');
var axios = _interopDefault(require('axios'));
var styledComponents = require('./styled-components.js');
var utils = require('./utils.js');

var fmPrefix = 'componentLib.attachmentsButton';
var AddAttachmentsButton = function (props) {
    var uploadRequestConfig = props.uploadRequestConfig, uploadCreateHandler = props.uploadCreateHandler, uploadSuccessHandler = props.uploadSuccessHandler, uploadErrorHandler = props.uploadErrorHandler, removeAttachmentHandler = props.removeAttachmentHandler;
    var _a = React.useState([]), attachments = _a[0], setAttachments = _a[1];
    var _b = React.useState(Date.now), inputKey = _b[0], setInputKey = _b[1];
    var _c = React.useState(0), tableKey = _c[0], setTableKey = _c[1];
    var fm = utils.getIntlFormat(reactIntl.useIntl(), fmPrefix);
    var handleRemoveAndCancel = function (attachment) {
        if (attachment.cancelToken) {
            attachment.cancelToken.cancel();
        }
        else {
            var updatedAttachments_1 = tslib.__spreadArrays(attachments);
            utils.processAttachmentByIndex(attachment.id, updatedAttachments_1, function (index) {
                updatedAttachments_1.splice(index, 1);
                setAttachments(updatedAttachments_1);
                removeAttachmentHandler(attachment);
            });
        }
    };
    var uploadErrorHandlerCallback = React.useCallback(uploadErrorHandler, []);
    var uploadSuccessHandlerCallback = React.useCallback(uploadSuccessHandler, []);
    var sendRequest = React.useCallback(function (attachedFile) {
        var data = new FormData();
        data.append('file', attachedFile.file, attachedFile.file.name);
        var source = axios.CancelToken.source();
        var config = {
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                var updatedAttachments = tslib.__spreadArrays(attachments);
                utils.processAttachmentByIndex(attachedFile.id, updatedAttachments, function (index) {
                    updatedAttachments[index].progress = percentCompleted;
                    setAttachments(updatedAttachments);
                });
            },
            cancelToken: source.token,
        };
        var newAttachments = tslib.__spreadArrays(attachments);
        utils.processAttachmentByIndex(attachedFile.id, newAttachments, function (index) {
            newAttachments[index].cancelToken = source;
            setAttachments(newAttachments);
        });
        return (axios(tslib.__assign(tslib.__assign(tslib.__assign({}, uploadRequestConfig), { data: data }), config))
            .then(function (result) {
            var updatedAttachments = tslib.__spreadArrays(attachments);
            utils.processAttachmentByIndex(attachedFile.id, updatedAttachments, function (index) {
                updatedAttachments[index].status = 'complete';
                updatedAttachments[index].cancelToken = undefined;
                setAttachments(updatedAttachments);
                uploadSuccessHandlerCallback(updatedAttachments[index], result.data);
            });
            return result;
        })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .catch(function (error) {
            var updatedAttachments = tslib.__spreadArrays(attachments);
            utils.processAttachmentByIndex(attachedFile.id, updatedAttachments, function (index) {
                if (axios.isCancel(error)) {
                    updatedAttachments[index].status = 'cancelled';
                }
                else {
                    updatedAttachments[index].status = 'error';
                }
                updatedAttachments[index].cancelToken = undefined;
                setAttachments(updatedAttachments);
            });
            uploadErrorHandlerCallback(error);
        }));
    }, [attachments, uploadErrorHandlerCallback, uploadRequestConfig, uploadSuccessHandlerCallback]);
    var uploadAttachments = React.useCallback(function (uploadingAttachments) { return tslib.__awaiter(void 0, void 0, void 0, function () {
        var updatedAttachments, promises, error_1;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedAttachments = tslib.__spreadArrays(attachments);
                    uploadingAttachments.forEach(function (upload) {
                        utils.processAttachmentByIndex(upload.id, updatedAttachments, function (index) {
                            updatedAttachments[index].status = 'uploading';
                        });
                    });
                    setAttachments(updatedAttachments);
                    promises = uploadingAttachments.map(function (upload) { return sendRequest(upload); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all(promises)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    uploadErrorHandlerCallback(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [attachments, sendRequest, uploadErrorHandlerCallback]);
    var handleFileUpload = function (event) {
        // This next line forces the <input> to rerender and so resets it. This allows
        // the selection of the same file twice.
        setInputKey(Date.now());
        var _a = utils.createNewAttachmentsState(event, attachments), newAttachments = _a.attachments, _b = _a.toRemove, toRemove = _b === void 0 ? [] : _b;
        setAttachments(newAttachments);
        if (toRemove.length) {
            toRemove.forEach(function (attachment) {
                if (attachment.cancelToken) {
                    attachment.cancelToken.cancel();
                }
            });
            removeAttachmentHandler.apply(void 0, toRemove);
        }
        uploadCreateHandler(newAttachments);
    };
    React.useEffect(function () {
        var uploadsToStart = attachments.filter(function (attachment) { return attachment.status === 'notstarted'; });
        if (uploadsToStart.length) {
            uploadAttachments(uploadsToStart);
        }
        var cancelledUploads = attachments.filter(function (attachment) { return attachment.status === 'cancelled'; });
        if (cancelledUploads && cancelledUploads.length) {
            var updatedAttachments_2 = tslib.__spreadArrays(attachments);
            cancelledUploads.forEach(function (cancelledUpload) {
                utils.processAttachmentByIndex(cancelledUpload.id, updatedAttachments_2, function (index) {
                    updatedAttachments_2.splice(index, 1);
                });
            });
            setAttachments(updatedAttachments_2);
            // This next line forces the <table> to rerender
            setTableKey(tableKey + 1);
        }
    }, [attachments, uploadAttachments, tableKey]);
    var rows = utils.attachmentsToRows(attachments);
    var showAttachmentsTable = !!(attachments && attachments.length);
    return (React__default.createElement(styledComponents.AttachmentButtonContainer, null,
        showAttachmentsTable && (React__default.createElement(styledComponents.TableContainer, { key: tableKey },
            React__default.createElement(StandardTable, { headCells: utils.getTableHeaderNames(fm), rows: rows, generateRow: utils.getGenerateRow(handleRemoveAndCancel, fm), dense: true }))),
        React__default.createElement(styledComponents.HiddenInput, { type: 'file', "data-testid": 'email_attachments', id: 'email_attachments', name: 'email_attachments', key: inputKey, onChange: handleFileUpload, multiple: true }),
        React__default.createElement(styledComponents.LabelContainer, null,
            React__default.createElement(styledComponents.StyledLabel, { htmlFor: 'email_attachments' },
                React__default.createElement(SmallLinkText, null, "+ " + fm('attachments'))))));
};

module.exports = AddAttachmentsButton;
